import React from 'react';

const Loader = () => {
  return (
    <div className='Loader_Container'>
      <div className='load'></div>
    </div>
  );
};

export default Loader;
